<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <section id="login-form" class="container-fluid banner-img" style="overflow-x: hidden; overflow-y: auto;">
    <div class="row hv-100 justify-content-center align-items-center" style="overflow-x: hidden; overflow-y: auto;">
      <div class="col-md-12 p-4 wow bounceInUp" style="overflow-x: hidden; overflow-y: auto;">
        <!-- form card login -->
        <div class="card bdr-r-25" style="overflow-x: hidden; overflow-y: auto;">
          <table class="table" style="background-color:white;">

            <tr>
              <td style="background-color:#0f2b46;color:white;" colspan="2"><h4 class="m-0">Corporate/Company Sign Up </h4></td>
              <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
            </tr>
          </table>

          <div class="card-body" style="overflow-x: hidden; overflow-y: auto;">
            <form class="form" [formGroup]="myForm" autocomplete="off">

              <div class="row">
                <div class="col-lg-12 pb-3">
                  <label for="" class="font-weight-bold">Select Currency Country :</label>
                  <div id="">
                    <select class="form-control" formControlName="serviceid"
                            [ngClass]="{ 'is-invalid': submitted && f.serviceid.errors }">
                      <option value="null">Select Currency Country</option>
                      <option [value]="d?.serviceId" *ngFor="let d of ServiceCountryList">
                        {{d.serviceProvider}}
                      </option>
                    </select>
                  </div>
                </div>


                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold ">First Name :</label>
                  <div id="">
                    <input type="text" name="" class="form-control" formControlName="firstName"
                           maxlength="50" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
                  </div>
                </div>
                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold ">Last Name :</label>
                  <div id="">
                    <input type="text" name="" class="form-control" formControlName="lastName"
                           maxlength="50" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                  </div>
                </div>
                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold">Email :</label>
                  <div id="">
                    <input type="email" name="" class="form-control" formControlName="emailId"
                           maxlength="100" [ngClass]="{ 'is-invalid': submitted && f.emailId.errors }" />
                  </div>
                </div>
                <div class="col-lg-4 pb-3" *ngIf="isAdd">
                  <label for="" class="font-weight-bold">Password :</label>
                  <div id="">
                    <input type="password" name="" class="form-control" formControlName="password"
                           maxlength="20" minlength="8" [ngClass]="{ 'is-invalid': submitted && !f.password.value }" />
                  </div>
                  <span style="color: red;" *ngIf="f.password.hasError('pattern')">
                    Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
                  </span>
                </div>
                <div class="col-lg-4 pb-3" *ngIf="isAdd">
                  <label for="" class="font-weight-bold">Confirm Password :</label>
                  <div id="">
                    <input type="password" name="" class="form-control" formControlName="ConfirmPassword"
                           maxlength="20" minlength="8" [ngClass]="{ 'is-invalid': submitted && (!f.ConfirmPassword.value || f.ConfirmPassword.value!== f.password.value) }" />
                  </div>
                  <span style="color: red;" *ngIf="f.ConfirmPassword.hasError('pattern')">
                    Confirm Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
                  </span>
                  <span style="color: red;" *ngIf="f.ConfirmPassword.hasError('confirmPasswordValidator')">
                    Password and Confirm Password must be match
                  </span>
                </div>
                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold">Company :</label>
                  <div id="">
                    <input type="text" name="" class="form-control" formControlName="company"
                           maxlength="80" [ngClass]="{ 'is-invalid': submitted && f.company.errors }" />
                  </div>
                </div>
                <div class="col-lg-6 pb-3">
                  <label for="" class="font-weight-bold">Select Country:</label>
                  <div id="">
                    <select class="form-control" formControlName="isdCode"
                            [ngClass]="{ 'is-invalid': submitted && f.isdCode.errors }">
                      <option value="null">Select Country</option>
                      <option [value]="d?.isdCode" *ngFor="let d of isdCodeList">
                        {{d?.name}}({{d?.isdCodeText}})
                      </option>
                    </select>
                  </div>

              

                </div>
                <div class="col-lg-6 pb-3">
                  <label for="" class="font-weight-bold">Mobile No. :</label>
                  <div id="">
                 
                    <input type="text" NumberOnly class="form-control" formControlName="mobileNo"
                           minlength="1" maxlength="13" [ngClass]="{ 'is-invalid': submitted && f.mobileNo.errors }" />
                  </div>
                </div>
                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold">Business License :</label>
                  <div id="">
                    <input type="text" class="form-control" formControlName="businessLicense"
                           maxlength="80" [ngClass]="{ 'is-invalid': submitted && f.businessLicense.errors }" />
                  </div>
                </div>
                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold">TIN :</label>
                  <div id="">
                    <input type="text" class="form-control" formControlName="tin" maxlength="80"
                           [ngClass]="{ 'is-invalid': submitted && f.tin.errors }" />
                  </div>
                </div>
                <div class="col-lg-4 pb-3">
                  <label for="" class="font-weight-bold">VAT :</label>
                  <div id="">
                    <input type="text" class="form-control" formControlName="vat" maxlength="80"
                           [ngClass]="{ 'is-invalid': submitted && f.vat.errors }" />
                  </div>
                </div>
                <div class="col-lg-6 pb-3">
                  <label for="" class="font-weight-bold">Corporate/Company Address :</label>
                  <div id="">
                    <textarea type="text" name="" class="form-control" formControlName="merchantAddress"
                              maxlength="500" [ngClass]="{ 'is-invalid': submitted && f.merchantAddress.errors }"></textarea>

                  </div>
                </div>

                <div class="col-lg-6 pb-3">
                  <label for="" class="font-weight-bold">Postal Code:</label>
                  <div id="">
                    <textarea type="text" name="" class="form-control" formControlName="postalCode"
                              [ngClass]="{ 'is-invalid': submitted && f.postalCode.errors }" maxlength="80"></textarea>

                  </div>
                </div>
                <div class="col-lg-12">
                  <h4>Bank Details</h4>
                  <div class="card px-3 py-3">
                    <div class="row">
                      <div class="col-lg-4 pb-3">
                        <label for="" class="font-weight-bold">Bank Name :</label>
                        <div id="">
                          <input type="text" class="form-control" formControlName="bankName"
                                 maxlength="80" [ngClass]="{ 'is-invalid': submitted && f.bankName.errors }" />
                        </div>
                      </div>
                      <div class="col-lg-4 pb-3">
                        <label for="" class="font-weight-bold">Account Number :</label>
                        <div id="">
                          <input type="text" class="form-control" formControlName="accountNumber"
                                 maxlength="80" [ngClass]="{ 'is-invalid': submitted && f.accountNumber.errors }" />
                        </div>
                      </div>
                      <div class="col-lg-4 pb-3">
                        <label for="" class="font-weight-bold">Bank Code :</label>
                        <div id="">
                          <input type="text" class="form-control" formControlName="bankCode"
                                 maxlength="80" [ngClass]="{ 'is-invalid': submitted && f.bankCode.errors }" />
                        </div>
                      </div>


                    </div>

                  </div>
                  <hr>
                </div>


                <div class=" col-lg-12 d-flex justify-content-end align-items-center mt-2">
                  <button class="btn col-md-2 btn-primary  text-white mr-2" type="button"
                          (click)="save(myForm.value)">
                    Save
                  </button>
                  <button class="btn col-md-2 btn-secondary  text-white" type="button"
                          [mat-dialog-close]="false">
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>

      </div>
    </div>

  </section>
</fieldset>
